import React, { useCallback } from 'react';
import { Flex, Stack } from '@grubhubprod/gh-cookbook-react';
import { InsightsDateRangeControl } from 'src/components/common/InsightsDateRangeControl/InsightsDateRangeControl';
import { InsightsFormFields } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/components/InsightsFormWrapper/InsightsFormWrapper';
import { useInsightsAutoSubmit } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/hooks/useInsightsAutoSubmit';
import { InsightsLocationsControl } from 'src/components/common/InsightsLocationsControl/InsightsLocationsControl';
import {
  DATE_RANGE_KEY,
  INSIGHTS_LOCATIONS_KEY,
} from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/constants/businessInsights';
import { getReportFilterValues } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/utils/formatFilterValues';
import { useBusinessInsightsContext } from 'src/components/enterprise/features/HomePage/BusinessAdminInsights/hooks/useBusinessInsightsContext';

const MAX_FILTERS_WIDTH = '250px';

export function InsightsFilters(): JSX.Element {
  const { applyFilters, filterDetails } = useBusinessInsightsContext();

  const handleSubmit = useCallback(
    (data: InsightsFormFields): void => {
      const filterValues = getReportFilterValues(data, filterDetails);

      applyFilters(filterValues);
    },
    [applyFilters, filterDetails]
  );

  useInsightsAutoSubmit({ onSubmit: handleSubmit });

  return (
    <Flex justifyContent="flex-end" width="100%" height="100%" alignItems="end">
      <Stack flex={1} maxWidth={MAX_FILTERS_WIDTH} x="x-sm">
        <InsightsDateRangeControl id={DATE_RANGE_KEY} name={DATE_RANGE_KEY} />
      </Stack>
      <Stack flex={1} maxWidth={MAX_FILTERS_WIDTH}>
        <InsightsLocationsControl name={INSIGHTS_LOCATIONS_KEY} />
      </Stack>
    </Flex>
  );
}
